import List from "@/components/list";
import { tableBaseProps } from "@/utils/common.js";

const Table = (args) => {
  const { listeners, props } = args;
  const sortChange = listeners["sortChange"] || function() {};
  const tableConfig = props.tableConfig || [];

  // console.log(tableConfig, "tableConfig");

  const AccountTableConfig = [...tableConfig];
  return (
    <List {...args} talbeCols={AccountTableConfig} onSortChange={sortChange} />
  );
};
export default Table;
